import { render, staticRenderFns } from "./UserIdentifierV2.vue?vue&type=template&id=15257eb0"
import script from "./UserIdentifierV2.vue?vue&type=script&lang=js"
export * from "./UserIdentifierV2.vue?vue&type=script&lang=js"
import style0 from "./UserIdentifierV2.vue?vue&type=style&index=0&id=15257eb0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports